var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        {
          staticClass: "title",
          attrs: { "align-baseline": "", "justify-space-between": "" }
        },
        [
          _c("v-flex", { attrs: { xs2: "" } }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("packageShipmentDetails")) + ":\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "hide-details": "",
                  items: _vm.templates,
                  "return-object": "",
                  label: _vm.$t("template"),
                  "item-text": "name"
                },
                on: { change: _vm.onSelectTemplate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(data) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: {
                                  "hide-details": "",
                                  value: _vm.shipDate,
                                  label: _vm.$t("shipDate"),
                                  readonly: ""
                                }
                              },
                              data.on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.shipDateMenu,
                    callback: function($$v) {
                      _vm.shipDateMenu = $$v
                    },
                    expression: "shipDateMenu"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    on: {
                      input: function($event) {
                        _vm.shipDateMenu = false
                      }
                    },
                    model: {
                      value: _vm.shipDate,
                      callback: function($$v) {
                        _vm.shipDate = $$v
                      },
                      expression: "shipDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _vm.isAutoGetRate && _vm.autoGetRate
                ? _c("v-autocomplete", {
                    attrs: {
                      items: _vm.allCarriers,
                      label: _vm.$t("autoGetRate"),
                      rules: [_vm.arrayLengthRule()],
                      multiple: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prepend-item",
                          fn: function() {
                            return [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { ripple: "" },
                                  on: {
                                    mousedown: function($event) {
                                      $event.preventDefault()
                                    },
                                    click: _vm.selectAll
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "#224855" } },
                                        [_vm._v(_vm._s(_vm.allIcon))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.$t("selectAll")) +
                                            "\n            "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", { staticClass: "mt-2" })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "append",
                          fn: function() {
                            return [
                              _c("v-checkbox", {
                                style: { height: "10px", marginTop: "-10px" },
                                attrs: { label: _vm.$t("autoGetRate") },
                                model: {
                                  value: _vm.autoGetRate,
                                  callback: function($$v) {
                                    _vm.autoGetRate = $$v
                                  },
                                  expression: "autoGetRate"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3103416608
                    ),
                    model: {
                      value: _vm.carriers,
                      callback: function($$v) {
                        _vm.carriers = $$v
                      },
                      expression: "carriers"
                    }
                  })
                : _c("v-select", {
                    attrs: {
                      "hide-details": "",
                      items: _vm.shippingServices,
                      "item-text": "text",
                      "item-value": "value",
                      "menu-props": { returnValue: "value" },
                      rules: [_vm.fieldIsRequired("service")],
                      label: _vm.$t("shippingService")
                    },
                    on: {
                      changeShippingService: function(e) {
                        return _vm.$emit("changeShippingService", e)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item",
                          fn: function(data) {
                            return [
                              _vm.isObject(data.item)
                                ? [
                                    _c("v-list-tile-content", {
                                      domProps: {
                                        textContent: _vm._s(data.item)
                                      }
                                    })
                                  ]
                                : [
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(data.item.text) +
                                              "\n              "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                            ]
                          }
                        },
                        _vm.isAutoGetRate
                          ? {
                              key: "append",
                              fn: function() {
                                return [
                                  _c("v-checkbox", {
                                    style: {
                                      height: "10px",
                                      marginTop: "-10px"
                                    },
                                    attrs: { label: _vm.$t("autoGetRate") },
                                    model: {
                                      value: _vm.autoGetRate,
                                      callback: function($$v) {
                                        _vm.autoGetRate = $$v
                                      },
                                      expression: "autoGetRate"
                                    }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.shippingService,
                      callback: function($$v) {
                        _vm.shippingService = $$v
                      },
                      expression: "shippingService"
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c("v-select", {
                staticClass: "table-item",
                attrs: {
                  "hide-details": "",
                  label: _vm.$t("labelStockType"),
                  items: _vm.labelStockTypes,
                  "item-text": "text",
                  "menu-props": { returnValue: "value" }
                },
                model: {
                  value: _vm.labelStockType,
                  callback: function($$v) {
                    _vm.labelStockType = $$v
                  },
                  expression: "labelStockType"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "justify-space-between": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  "hide-details": "",
                  items: [
                    {
                      name: _vm.$t("documents"),
                      value: "documents"
                    },
                    {
                      name: _vm.$t("Products/Commodities"),
                      value: "commodities"
                    }
                  ],
                  label: _vm.$t("packageContents"),
                  "item-text": "name",
                  "item-value": "value",
                  readonly: ""
                },
                model: {
                  value: _vm.packageContent,
                  callback: function($$v) {
                    _vm.packageContent = $$v
                  },
                  expression: "packageContent"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs2: "" } },
            [
              _c(_vm.isImportToUsByDHL ? "v-combobox" : "v-autocomplete", {
                tag: "component",
                class:
                  _vm.isAutoGetRate && _vm.autoGetRate && _vm.isGetRateAction
                    ? ""
                    : "required_field",
                attrs: {
                  items: _vm.shipmentPurposeItems,
                  label: _vm.$t("shipmentPurpose"),
                  rules: [_vm.shipmentPurposeValid(_vm.isGetRateAction)],
                  "hide-details": "",
                  "item-text": "name",
                  "item-value": "value",
                  "return-object": false
                },
                model: {
                  value: _vm.shipmentPurpose,
                  callback: function($$v) {
                    _vm.shipmentPurpose = $$v
                  },
                  expression: "shipmentPurpose"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: _vm.$t("signature"),
                  items: _vm.signatureOptions,
                  "item-text": "text",
                  "persistent-hint": "",
                  "hide-details": _vm.isImportToUsByDHL,
                  hint: _vm.isImportToUsByDHL
                    ? ""
                    : _vm.$t(
                        "signatureIsRequiredForFedExInternationalShipment"
                      ),
                  "menu-props": { returnValue: "value" }
                },
                model: {
                  value: _vm.signature,
                  callback: function($$v) {
                    _vm.signature = $$v
                  },
                  expression: "signature"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs3: "" } },
            [
              _vm.isShowBookingNumber
                ? _c("v-text-field", {
                    attrs: {
                      "hide-details": "",
                      label: _vm.$t("bookingConfirmationNumber"),
                      rules: [_vm.fieldIsRequired("qty")]
                    },
                    model: {
                      value: _vm.bookingConfirmationNumber,
                      callback: function($$v) {
                        _vm.bookingConfirmationNumber = $$v
                      },
                      expression: "bookingConfirmationNumber"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isImportToUsByDHL
                ? _c("v-autocomplete", {
                    attrs: {
                      label: _vm.$t("battery"),
                      items: _vm.batteries,
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.batteryLabel,
                      callback: function($$v) {
                        _vm.batteryLabel = $$v
                      },
                      expression: "batteryLabel"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isImportToUsByDHL
        ? _c(
            "v-layout",
            { attrs: { "justify-space-between": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs3: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "hide-details": "",
                      rules: [
                        function(v) {
                          return (
                            !v ||
                            (isNaN(v) &&
                              _vm.$t("fieldIsNumber", {
                                fieldName: "This field"
                              }))
                          )
                        }
                      ],
                      label: _vm.$t("freightCharges")
                    },
                    model: {
                      value: _vm.freightCharges,
                      callback: function($$v) {
                        _vm.freightCharges = _vm._n($$v)
                      },
                      expression: "freightCharges"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2 mt-2",
        attrs: {
          headers: _vm.headers,
          items: _vm.packages,
          "hide-actions": "",
          "item-key": "_key",
          expand: true
        },
        scopedSlots: _vm._u([
          {
            key: "expand",
            fn: function(props) {
              return [
                _vm.isLithiumBatteryDangerousGoods ||
                (props.item.isLithiumBattery &&
                  props.item.lithiumBatteryOptions &&
                  props.item.lithiumBatteryOptions.length > 0)
                  ? _c("LithiumBatteryDangerousGoods", {
                      attrs: {
                        props: props,
                        lithiumBatteryOptionItems: _vm.lithiumBatteryOptionItems
                      },
                      on: { applyAll: _vm.applyAllLithiumBattery }
                    })
                  : _vm._e()
              ]
            }
          },
          {
            key: "headerCell",
            fn: function(props) {
              return [
                props.header.value === "action"
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(tooltip) {
                                    return [
                                      _c(
                                        "div",
                                        _vm._g({}, tooltip.on),
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                flat: "",
                                                small: "",
                                                icon: "",
                                                disabled: !_vm.serviceSetting
                                                  .enableMWT
                                              },
                                              on: { click: _vm.addPackage }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                flat: "",
                                                small: "",
                                                icon: "",
                                                color: "primary",
                                                disabled: !_vm.serviceSetting
                                                  .enableMWT
                                              },
                                              on: {
                                                click: function() {
                                                  _vm.isOpenImportPackagesDialog = true
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("cloud_upload")
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("supportUpTo25Packages")) +
                                "\n        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : props.header.value === "weight"
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function($event) {
                            _vm.isOz = !_vm.isOz
                          }
                        }
                      },
                      [_vm._v(_vm._s(props.header.text))]
                    )
                  : props.header.value === "reference"
                  ? [
                      _c("v-select", {
                        attrs: {
                          "hide-details": "",
                          label: _vm.$t("reference"),
                          items: _vm.referenceOptions,
                          "item-text": "text",
                          "menu-props": { returnValue: "value" }
                        },
                        model: {
                          value: _vm.reference,
                          callback: function($$v) {
                            _vm.reference = $$v
                          },
                          expression: "reference"
                        }
                      })
                    ]
                  : _c("span", [_vm._v(_vm._s(props.header.text))])
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-xs-center" },
                    [
                      props.index > 0
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                flat: "",
                                small: "",
                                icon: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deletePackage(props.item)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("delete")])],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c("v-text-field", {
                        staticClass: "table-item",
                        attrs: {
                          "hide-details": "",
                          disabled: !_vm.serviceSetting.enableMWT,
                          rules: _vm.qtyRules
                        },
                        model: {
                          value: props.item.qty,
                          callback: function($$v) {
                            _vm.$set(props.item, "qty", _vm._n($$v))
                          },
                          expression: "props.item.qty"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c("v-text-field", {
                        staticClass: "table-item",
                        attrs: {
                          "hide-details": "",
                          rules: _vm.weightRules,
                          suffix: _vm.isMeasurementMetric
                            ? "kg"
                            : _vm.isOz
                            ? "Oz"
                            : "Lbs"
                        },
                        model: {
                          value: props.item.weightLb,
                          callback: function($$v) {
                            _vm.$set(props.item, "weightLb", _vm._n($$v))
                          },
                          expression: "props.item.weightLb"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "align-center": "" } },
                        [
                          _c(
                            "v-flex",
                            { staticClass: "mr-3", attrs: { xs4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "table-item",
                                attrs: {
                                  "hide-details": "",
                                  suffix: _vm.sizeSuffix,
                                  rules: _vm.lengthRules
                                },
                                model: {
                                  value: props.item.length,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "length", _vm._n($$v))
                                  },
                                  expression: "props.item.length"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "mr-3", attrs: { xs4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "table-item",
                                attrs: {
                                  "hide-details": "",
                                  suffix: _vm.sizeSuffix,
                                  rules: _vm.widthRules
                                },
                                model: {
                                  value: props.item.width,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "width", _vm._n($$v))
                                  },
                                  expression: "props.item.width"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "table-item",
                                attrs: {
                                  "hide-details": "",
                                  suffix: _vm.sizeSuffix,
                                  rules: _vm.heightRules
                                },
                                model: {
                                  value: props.item.height,
                                  callback: function($$v) {
                                    _vm.$set(props.item, "height", _vm._n($$v))
                                  },
                                  expression: "props.item.height"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs1: "" } },
                            [
                              _c("PackagingSelector", {
                                attrs: { packagings: _vm.packagings },
                                on: {
                                  select: function(item) {
                                    return _vm.onSelectPackaging(
                                      item,
                                      props.item
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c("v-text-field", {
                        staticClass: "table-item",
                        attrs: {
                          "hide-details": "",
                          disabled: !_vm.serviceSetting.enableInsured,
                          rules: _vm.declaredValueRules
                        },
                        model: {
                          value: props.item.declaredValue,
                          callback: function($$v) {
                            _vm.$set(props.item, "declaredValue", _vm._n($$v))
                          },
                          expression: "props.item.declaredValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "text-xs-left" },
                    [
                      _c("v-text-field", {
                        staticClass: "table-item",
                        attrs: {
                          "hide-details": "",
                          disabled: _vm.serviceSetting.disabledPkgMemo
                        },
                        model: {
                          value: props.item.memo,
                          callback: function($$v) {
                            _vm.$set(props.item, "memo", $$v)
                          },
                          expression: "props.item.memo"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.currentShippingService.enableReferences
                    ? _c(
                        "td",
                        { staticClass: "text-xs-left" },
                        [
                          _c("v-text-field", {
                            staticClass: "table-item",
                            attrs: {
                              "hide-details": "",
                              rules: [
                                _vm.fieldCharLimit(
                                  "Reference",
                                  _vm.currentShippingService.referenceLength ||
                                    40
                                )
                              ]
                            },
                            model: {
                              value: props.item.reference,
                              callback: function($$v) {
                                _vm.$set(props.item, "reference", $$v)
                              },
                              expression: "props.item.reference"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLithiumBatteryDangerousGoods
                    ? _c(
                        "td",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-layout",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                "align-center": "",
                                "justify-center": "",
                                id:
                                  "expand-icon-" +
                                  (props.item._key || props.index)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleExpand(props)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { color: "primary" }
                                },
                                [_vm._v("battery_charging_full")]
                              ),
                              _vm._v(" "),
                              _c("v-icon", [_vm._v("expand_more")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ImportPackagesDimensions", {
        attrs: { isShow: _vm.isOpenImportPackagesDialog },
        on: { confirmMethod: _vm.loadDimensionsData },
        model: {
          value: _vm.isOpenImportPackagesDialog,
          callback: function($$v) {
            _vm.isOpenImportPackagesDialog = $$v
          },
          expression: "isOpenImportPackagesDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7960b491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7960b491","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EeiPackageWidget.vue
// module id = null
// module chunks = 